import { forwardRef } from 'react'

type Props = {
  label: string;
}

const Thumb = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { label } = props;
  return (
    <div
      {...props}
      ref={ref}
      className="rate-slider__thumb"
    >
      <i className="ri-arrow-left-s-line text-secondary" />
      {label}
      <i className="ri-arrow-right-s-line text-secondary" />
    </div>
  )
})

export default Thumb
